(function () {

  function isGrid(section) {
    return section.dataset.layout === 'grid';
  }


  function scrollByItem(track, direction) {

    var item = track.querySelector('[data-item]');

    if (!item) return;

    var gap = 16;
    var width = item.getBoundingClientRect().width;

    track.scrollBy({
      left: direction * (width + gap),
      behavior: 'smooth'
    });

  }


  function updateArrowState(track, prevBtn, nextBtn) {

    if (prevBtn) {
      prevBtn.disabled = track.scrollLeft <= 4;
    }

    if (nextBtn) {

      var maxScroll =
        track.scrollWidth - track.clientWidth;

      nextBtn.disabled =
        track.scrollLeft >= maxScroll - 4;

    }

  }


  function setupAutoplay(section, track) {

    /*
     * Grid não utiliza autoplay.
     */
    if (isGrid(section)) return;

    if (section.dataset.autoplay !== 'true') return;

    var speed =
      parseInt(
        section.dataset.autoplaySpeed,
        10
      ) || 3000;


    var timer = setInterval(function () {

      var maxScroll =
        track.scrollWidth - track.clientWidth;


      if (track.scrollLeft >= maxScroll - 4) {

        track.scrollTo({
          left: 0,
          behavior: 'smooth'
        });

      } else {

        scrollByItem(track, 1);

      }

    }, speed);


    /*
     * Pausa quando o usuário interagir.
     */
    ['pointerdown', 'wheel'].forEach(function (evt) {

      track.addEventListener(
        evt,
        function () {
          clearInterval(timer);
        },
        {
          once: true,
          passive: true
        }
      );

    });

  }


  function setupArrows(
    section,
    track,
    prevBtn,
    nextBtn
  ) {

    if (isGrid(section)) return;


    if (prevBtn) {

      prevBtn.addEventListener(
        'click',
        function () {
          scrollByItem(track, -1);
        }
      );

    }


    if (nextBtn) {

      nextBtn.addEventListener(
        'click',
        function () {
          scrollByItem(track, 1);
        }
      );

    }


    if (!prevBtn && !nextBtn) return;


    updateArrowState(
      track,
      prevBtn,
      nextBtn
    );


    var ticking = false;


    track.addEventListener(
      'scroll',
      function () {

        if (ticking) return;

        window.requestAnimationFrame(
          function () {

            updateArrowState(
              track,
              prevBtn,
              nextBtn
            );

            ticking = false;

          }
        );

        ticking = true;

      },
      {
        passive: true
      }
    );


    window.addEventListener(
      'resize',
      function () {

        updateArrowState(
          track,
          prevBtn,
          nextBtn
        );

      }
    );

  }


  function setupDots(
    section,
    track,
    items,
    dots
  ) {

    if (isGrid(section)) return;

    if (!items.length || !dots.length) return;


    if ('IntersectionObserver' in window) {

      var observer =
        new IntersectionObserver(

          function (entries) {

            entries.forEach(
              function (entry) {

                if (!entry.isIntersecting) {
                  return;
                }


                var index =
                  Array.prototype.indexOf.call(
                    items,
                    entry.target
                  );


                dots.forEach(
                  function (dot, i) {

                    dot.classList.toggle(
                      'is-active',
                      i === index
                    );

                  }
                );

              }
            );

          },

          {
            root: track,
            threshold: 0.6
          }

        );


      items.forEach(
        function (item) {
          observer.observe(item);
        }
      );

    }


    dots.forEach(
      function (dot) {

        dot.addEventListener(
          'click',
          function () {

            var index =
              parseInt(
                dot.getAttribute('data-dot'),
                10
              );


            if (!items[index]) return;


            items[index].scrollIntoView({
              behavior: 'smooth',
              inline: 'start',
              block: 'nearest'
            });

          }
        );

      }
    );

  }


  function initCarousel(section) {

    var track =
      section.querySelector('[data-track]');

    if (!track) return;


    var items =
      section.querySelectorAll('[data-item]');

    var dots =
      section.querySelectorAll('[data-dot]');

    var prevBtn =
      section.querySelector('[data-carousel-prev]');

    var nextBtn =
      section.querySelector('[data-carousel-next]');


    /*
     * No Grid, o JS não inicializa
     * funcionalidades de carrossel.
     */
    if (isGrid(section)) {
      return;
    }


    setupArrows(
      section,
      track,
      prevBtn,
      nextBtn
    );


    setupDots(
      section,
      track,
      items,
      dots
    );


    if (items.length > 1) {

      setupAutoplay(
        section,
        track
      );

    }

  }


  function loadRelated(section) {

    var url =
      section.getAttribute(
        'data-recommendations-url'
      );

    if (!url) return;


    fetch(url)

      .then(
        function (response) {
          return response.text();
        }
      )

      .then(
        function (text) {

          var wrapper =
            document.createElement('div');

          wrapper.innerHTML = text;


          var fresh =
            wrapper.querySelector(
              '#' + section.id
            );


          if (
            fresh &&
            fresh.querySelector('[data-item]')
          ) {

            section.innerHTML =
              fresh.innerHTML;


            /*
             * Reaplica as configurações
             * depois do carregamento AJAX.
             */
            var freshLayout =
              fresh.getAttribute('data-layout');


            if (freshLayout) {

              section.setAttribute(
                'data-layout',
                freshLayout
              );

            }


            initCarousel(section);

          } else {

            section.remove();

          }

        }
      )

      .catch(
        function () {
          section.remove();
        }
      );

  }


  /*
   * Inicialização.
   */
  var sections =
    document.querySelectorAll(
      '[data-featured-carousel]'
    );


  sections.forEach(
    function (section) {

      if (
        section.hasAttribute(
          'data-recommendations-url'
        )
      ) {

        loadRelated(section);

      } else {

        initCarousel(section);

      }

    }
  );


})();